import { useLang } from "@/i18n/LangContext";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import UseCases from "@/components/UseCases";
import EcosystemGraph from "@/components/EcosystemGraph";
import Packages from "@/components/Packages";

export default function Solutions() {
  const { t } = useLang();
  return (
    <>
      <Seo page="solutions" />
      <section className="bg-ink bg-grid-dark pt-[140px] pb-16 lg:pt-[180px] lg:pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="text-xs font-semibold tracking-[0.25em] text-electric">{t("solutions.eyebrow")}</p>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight max-w-3xl">{t("solutions.title")}</h1>
            <p className="mt-5 max-w-2xl text-base sm:text-lg text-steel leading-relaxed">{t("solutions.sub")}</p>
          </Reveal>
        </div>
      </section>
      <UseCases />
      <EcosystemGraph />
      <Packages />
    </>
  );
}
